import type { WindowKey } from 'owa-bizchat-types';
import getProjection from 'owa-popout-v2/lib/utils/getProjection';

/**
 * Generates a unique key for the target window.
 * If the target window is an immersive BizChat screen, the key will be prefixed with 'Immersive'.
 * Otherwise, it will be prefixed with 'SidePane'.
 * For the main window scenarios (both sidepane and immersive), the suffix will be an empty string.
 */
export function getBizChatWindowKey(
    targetWindow: Window | undefined,
    isImmersiveBizchat?: boolean
): WindowKey {
    const suffix = targetWindow ? getProjection(targetWindow)?.tabId ?? '' : '';
    if (isImmersiveBizchat) {
        return `Immersive${suffix}`;
    }
    return `SidePane${suffix}`;
}
